"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _constants = require("./constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _commonConstants = require("../../../../utils/common-constants");

var _lodash = require("lodash");

var _commonUtils = require("../../../../utils/common-utils");

var _pillClass;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.approvals-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .approvals-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .approvals-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n  .approvals-header-class .header-class .margin-top-10 {\n    margin-top: 0.625rem; }\n\n.approvals-header-class .approval-loader-container {\n  display: flex;\n  justify-content: center; }\n\n.approvals-header-class .secret-view-policy-permission-action-pill-container {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n  margin-right: 1rem; }\n\n.approval-channel-list-container {\n  max-width: 32rem;\n  max-height: 6.25rem;\n  overflow: auto;\n  padding: 0.3125rem;\n  margin-top: 0.5rem; }\n";
  var fileName = "compone_ViewApprovals";
  var element = document.querySelector("style[data-sass-component='compone_ViewApprovals']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var pillClass = (_pillClass = {}, _defineProperty(_pillClass, _constants.classes.marginTop10, true), _defineProperty(_pillClass, _constants.classes.tagsContainer, true), _pillClass);

function PolicyViewApprovals(_ref) {
  var _approvalData$manager, _approvalData$manager2, _approvalData$manager3, _approvalData$manager4, _approvalMembersData$, _approvalMembersData$2;

  var policyViewData = _ref.policyViewData,
      fetchedUsers = _ref.fetchedUsers,
      fetchedGroups = _ref.fetchedGroups,
      notificationMediumData = _ref.notificationMediumData,
      notificationMediumDataStatus = _ref.notificationMediumDataStatus,
      translatedStrings = _ref.translatedStrings,
      approvalLabels = _ref.approvalLabels,
      viewPolicyHeaders = _ref.viewPolicyHeaders;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      channelList = _useState2[0],
      setChannelList = _useState2[1];

  var _ref2 = !(0, _lodash.isEmpty)(policyViewData) ? policyViewData : '{}',
      _ref2$approval = _ref2.approval,
      approvalData = _ref2$approval === void 0 ? {} : _ref2$approval;

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      approvalMembersData = _useState4[0],
      setApprovalMembersData = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!(0, _lodash.isEmpty)(approvalData) && !(0, _commonUtils.isLoading)(notificationMediumDataStatus)) {
      var _approvalData$approve, _approvalData$approve2, _approvalData$approve3;

      var fetchedMembers = {
        users: fetchedUsers,
        groups: fetchedGroups
      };
      var data = {
        users: approvalData === null || approvalData === void 0 ? void 0 : (_approvalData$approve = approvalData.approvers) === null || _approvalData$approve === void 0 ? void 0 : _approvalData$approve.userIds,
        tags: approvalData === null || approvalData === void 0 ? void 0 : (_approvalData$approve2 = approvalData.approvers) === null || _approvalData$approve2 === void 0 ? void 0 : _approvalData$approve2.tags,
        channels: approvalData === null || approvalData === void 0 ? void 0 : (_approvalData$approve3 = approvalData.approvers) === null || _approvalData$approve3 === void 0 ? void 0 : _approvalData$approve3.channelIds
      };
      var members = (0, _commonUtils.getMembers)(data, fetchedMembers, true);
      setApprovalMembersData(members);
    }
  }, [fetchedUsers, fetchedGroups, notificationMediumDataStatus]);
  (0, _react.useEffect)(function () {
    if (!(0, _lodash.isEmpty)(policyViewData)) {
      var _conditionJSON$approv, _conditionJSON$approv2, _conditionJSON$approv3;

      var conditionJSON = !(0, _lodash.isEmpty)(policyViewData) && policyViewData;
      var channelListNew = (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv = conditionJSON.approval) === null || _conditionJSON$approv === void 0 ? void 0 : (_conditionJSON$approv2 = _conditionJSON$approv.approvers) === null || _conditionJSON$approv2 === void 0 ? void 0 : (_conditionJSON$approv3 = _conditionJSON$approv2.channelIds) === null || _conditionJSON$approv3 === void 0 ? void 0 : _conditionJSON$approv3.join(', ')) || '';
      channelListNew && setChannelList(channelListNew);
    }
  }, [policyViewData]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerClass
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, viewPolicyHeaders === null || viewPolicyHeaders === void 0 ? void 0 : viewPolicyHeaders.approvals)), (0, _commonUtils.isLoading)(notificationMediumDataStatus) ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.approvalLoaderContainer
  }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: _commonConstants.medium
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels.approvalRequired), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, !(0, _lodash.isEmpty)(notificationMediumData) ? translatedStrings.yesText : translatedStrings.noText))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels.notification), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, !(0, _lodash.isEmpty)(notificationMediumData) ? notificationMediumData === null || notificationMediumData === void 0 ? void 0 : notificationMediumData.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: JSON.stringify(item)
    }, /*#__PURE__*/_react.default.createElement("ul", {
      style: {
        paddingLeft: '15px'
      }
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label1"
    }, item.name))));
  }) : /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, translatedStrings.noneText))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels === null || approvalLabels === void 0 ? void 0 : approvalLabels.managerApprovalLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, approvalData !== null && approvalData !== void 0 && (_approvalData$manager = approvalData.managerApproval) !== null && _approvalData$manager !== void 0 && _approvalData$manager.required ? translatedStrings.yesText : translatedStrings.noText)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "Condition:", ' ', (approvalData === null || approvalData === void 0 ? void 0 : (_approvalData$manager2 = approvalData.managerApproval) === null || _approvalData$manager2 === void 0 ? void 0 : _approvalData$manager2.condition) === 'Any' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Manager ", /*#__PURE__*/_react.default.createElement("strong", null, "OR"), " Approvers") : (approvalData === null || approvalData === void 0 ? void 0 : (_approvalData$manager3 = approvalData.managerApproval) === null || _approvalData$manager3 === void 0 ? void 0 : _approvalData$manager3.condition) === 'All' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Manager ", /*#__PURE__*/_react.default.createElement("strong", null, "AND"), " Approvers") : (approvalData === null || approvalData === void 0 ? void 0 : (_approvalData$manager4 = approvalData.managerApproval) === null || _approvalData$manager4 === void 0 ? void 0 : _approvalData$manager4.condition) === 'Manager' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Manager ", /*#__PURE__*/_react.default.createElement("strong", null, "Only")) : translatedStrings.noneText))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels.userListLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, pillClass))
  }, approvalMembersData !== null && approvalMembersData !== void 0 && approvalMembersData.users ? approvalMembersData === null || approvalMembersData === void 0 ? void 0 : (_approvalMembersData$ = approvalMembersData.users) === null || _approvalMembersData$ === void 0 ? void 0 : _approvalMembersData$.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: JSON.stringify(item),
      className: _constants.classes.viewPolicyPermissionActionPillContainer
    }, /*#__PURE__*/_react.default.createElement(_pill.default, {
      readOnly: true,
      key: item.name,
      label: item.name
    }));
  }) : /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, translatedStrings.noneText)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels.tagListLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, pillClass))
  }, approvalMembersData !== null && approvalMembersData !== void 0 && approvalMembersData.tags ? approvalMembersData === null || approvalMembersData === void 0 ? void 0 : (_approvalMembersData$2 = approvalMembersData.tags) === null || _approvalMembersData$2 === void 0 ? void 0 : _approvalMembersData$2.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: JSON.stringify(item),
      className: _constants.classes.viewPolicyPermissionActionPillContainer
    }, /*#__PURE__*/_react.default.createElement(_pill.default, {
      readOnly: true,
      key: item.name,
      label: item.name
    }));
  }) : /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, translatedStrings.noneText)))), (notificationMediumData === null || notificationMediumData === void 0 ? void 0 : notificationMediumData.type) === _commonConstants.IS_SLACK && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels.channelListLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.channelListContainer
  }, channelList ? /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, channelList) : /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, translatedStrings.noneText))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", approvalLabels.time, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, isNaN(Number(approvalData === null || approvalData === void 0 ? void 0 : approvalData.timeToApprove)) ? translatedStrings.noneText : (0, _commonUtils.getTimeInHMFromMinutes)(approvalData === null || approvalData === void 0 ? void 0 : approvalData.timeToApprove, translatedStrings)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, approvalLabels.maxValidTimeLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, approvalData !== null && approvalData !== void 0 && approvalData.validFor && approvalData !== null && approvalData !== void 0 && approvalData.isValidForInDays ? (approvalData === null || approvalData === void 0 ? void 0 : approvalData.validFor) + ' ' + translatedStrings.days : (0, _commonUtils.getTimeInHMFromMinutes)(approvalData === null || approvalData === void 0 ? void 0 : approvalData.validFor, translatedStrings))))));
}

PolicyViewApprovals.propTypes = {
  policyViewData: _propTypes.default.string,
  fetchedGroups: _propTypes.default.array,
  fetchedUsers: _propTypes.default.array,
  notificationMediumData: _propTypes.default.array,
  notificationMediumDataStatus: _propTypes.default.string,
  channelListStatus: _propTypes.default.string,
  channelListData: _propTypes.default.array,
  translatedStrings: _propTypes.default.object,
  approvalLabels: _propTypes.default.shape({
    approvalRequired: _propTypes.default.string,
    notification: _propTypes.default.string,
    type: _propTypes.default.string,
    approvers: _propTypes.default.string,
    time: _propTypes.default.string,
    userListLabel: _propTypes.default.string,
    tagListLabel: _propTypes.default.string,
    channelListLabel: _propTypes.default.string,
    maxValidTimeLabel: _propTypes.default.string,
    managerApprovalLabel: _propTypes.default.string
  }),
  viewPolicyHeaders: _propTypes.default.shape({
    general: _propTypes.default.string,
    members: _propTypes.default.string,
    generic: _propTypes.default.string,
    approvals: _propTypes.default.string
  }),
  consumer: _propTypes.default.string,
  channelList: _propTypes.default.string
};
var _default = PolicyViewApprovals;
exports.default = _default;